<div class="view-component">
    <div class="view-component-body">
        
        <nz-card class="toolbar" [nzTitle]="headerTemplate">
            
            
            <div class="content">
                <div class="cardcontent">
                    
                    <div class="esquerda" >
                        <div class="div90"  >
                            
                                <div class="mktplace-info">
                                    <search-input-new 
                                    [searchProperties]="searchInputCodeCompany"  class="full-width" [(ngModel)]="codecompany"
                                    (onChangeData)="onChangeCompanyData($event)"
                                    ></search-input-new>
                                </div>
                                <div class="mktplace-info">
                                    <search-input-new 
                                    [searchProperties]="searchActiveCompanies"  [variables]="variables"  [changes]="changeCompany" class="full-width" [(ngModel)]="codemktp"
    
                                    ></search-input-new>
                                    @if( codemktp?.key == 3){
                                        Fulfillment
                                        <nz-switch 
                                            [nzSize]="'small'"
                                            [(ngModel)]="isFull" >
                                            
                                        </nz-switch>
                                    }
                                </div>
                                <div class="mktplace-info">
                                     @if(codemktp?.key == 3){
                                         <nz-input-search [nzLoading]="wait" nzEnterButton (nzSearch)="getOrderIdMeli(input)">
                                             <input nz-input [placeholder]="'push_pedidos.buscaporcarrinho'|translateTA" [disabled]='codemktp? false: true' [(ngModel)]="input" (paste)="onPaste($event)"/>
                                             <nz-icon nzInputSuffix nzType="check" (click)="add(input)" class="trigger-icon"/>
                                         </nz-input-search>
                                     }@else {
                                        <nz-input-wrapper>
                                            <input nz-input [placeholder]="'push_pedidos.buscarpornumero'|translateTA" [(ngModel)]="input" [disabled]='codemktp? false: true' /> 
                                            <nz-icon nzInputSuffix nzType="check" (click)="add(input)" class="trigger-icon"/>
                                        </nz-input-wrapper>
                                     }
                                </div>
                                
                                <div class="div55">
                                    <ul nz-list nzBordered [nzDataSource]="listpedidos" nzBordered class="customlist">
                                        @for (item of listpedidos; track item.pedido) {
                                            <li nz-list-item nzNoFlex>
                                                <ul nz-list-item-actions>
                                                    <nz-list-item-action>
                                                        <a (click)="remove(item)">{{'remove'|translateTA}}</a>
                                                    </nz-list-item-action>
                                                </ul>
                                                {{ item.pedido }} - {{item.companyname}} - {{item.MktpName}}
                                            </li>
                                           
                                        }
                                        <nz-list-footer>

                                                <div class="buttondiv">
                                                    {{'push_pedidos.totalpedidos'|translateTA}}: {{listpedidos.length}}
                                                    <button nz-button nzType="primary" (click)="clear()" nz-tooltip [nzTooltipTitle]="'push_pedidos.limparlista'|translateTA">
                                                         <nz-icon nzType="delete" nzTheme="outline"></nz-icon>                                                     
                                                    </button>
                                                </div>
                                            
                                        </nz-list-footer>
                                    </ul>
                                </div>
                            
                        </div>
                        
                        
                        
                    </div>
                    <nz-divider nzType="vertical" nzVariant="solid"  class="div-pedido">   </nz-divider>
                    <div class="direita">
                        <div class="div100">
                            <h4>{{'push_pedidos.processamento'|translateTA}}</h4>
                        </div>
                        <div class="customlistdireita">
                            <ul nz-list nzBordered [nzDataSource]="listprocessamento" nzBordered class="customlist">
                                @for (item of listprocessamento; track item.pedido) {
                                <li nz-list-item nzNoFlex>
                                    <push-pedidos-stepper  [pedido]='item'></push-pedidos-stepper>
                                </li>
                            }
                            </ul>
                        </div>
                        <div class="div10">
                            <button nz-button nzType="primary" (click)="processar()" >  
                                Processar
                            </button>  
                        </div>
                    </div>
                </div>
            </div>

        </nz-card>
    </div>
</div>

<ng-template #headerTemplate>
    <div class="header-template">
                <span class="span">
                    {{'push_pedidos.titulo'|translateTA}}
                </span>
                <span class="span">
                    <nz-range-picker
                        [nzFormat]="'dd/MM/yyyy HH:mm:ss'"
                        [(ngModel)]="range"
                nzPlaceHolder="{{'push_pedidos.intervalo_datas'|translateTA}}"
                        [nzShowTime]="true">
                    </nz-range-picker>
                </span>
                <span class="span">
                    <label>{{'push_pedidos.ultima_atualizacao'|translateTA}}: {{atualizacao}}</label>
                </span>
                <span class="span">
                    <nz-input-wrapper class="search-full-width">
                        <input 
                            nz-input 
                            type="number"
                            placeholder="{{'push_pedidos.tempo_atualizacao'|translateTA}}" 
                            value="5"  
                            [ngModel]="time | number:'1.0-0'" 
                            pattern="[0-9]*"
                            (ngModelChange)="time = $event"
                            numbersOnly>
                    </nz-input-wrapper>
                </span>

                <span>
                    <button nz-button nzType="primary" (click)="refresh()" [nzLoading]="loading"   >
                        <nz-icon nzType="reload" nzTheme="outline"></nz-icon>
                    </button>
                </span>
            
            </div>
</ng-template>